var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-alt',{attrs:{"img":"https://image.freepik.com/photos-gratuite/chalkboard-points-interrogation-main-craie_1205-1001.jpg","title":"Foire Aux Questions","subtext":""}}),_c('faq',{attrs:{"data":_vm.faq}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }